import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import bgHero from "../images/bg-hero.png";
import svgArrowBtn from "../images/arrow-btn.svg";
import Logobgtransparentblack from "../images/DA_NoxZi/Logo-bg-transparent-black.png";
import Logobgblacktwhiterotate from "../images/DA_NoxZi/Logo-bg-black-twhite-rotate.png";

export default function ServicesPage() {
  const services = [
    {
      number: "01",
      title: "Applications mobiles sur mesure",
      description:
        "Nous concevons des applications iOS et Android pensées pour répondre à un vrai besoin métier, avec une logique produit claire, une expérience utilisateur fluide et une architecture robuste.",
      items: [
        "Développement iOS & Android",
        "React Native cross-platform",
        "Parcours utilisateur optimisé",
        "Publication App Store & Play Store",
      ],
    },
    {
      number: "02",
      title: "Sites web modernes",
      description:
        "Nous réalisons des sites web élégants, rapides et structurés pour renforcer votre image, améliorer votre présence en ligne et transformer vos visiteurs en prises de contact qualifiées.",
      items: [
        "Site vitrine premium",
        "Responsive sur tous les écrans",
        "Structure orientée conversion",
        "Base solide pour le SEO",
      ],
    },
    {
      number: "03",
      title: "UI / UX Design",
      description:
        "Chaque interface est pensée dans le détail pour offrir une expérience lisible, cohérente et haut de gamme. L'objectif n'est pas seulement d'être beau, mais d'être clair, utile et mémorable.",
      items: [
        "Wireframes & maquettes",
        "Design system cohérent",
        "Hiérarchie visuelle maîtrisée",
        "Prototype d'interfaces",
      ],
    },
    {
      number: "04",
      title: "Back-office & dashboards",
      description:
        "Nous développons aussi les outils internes qui donnent de la valeur au produit : interfaces d'administration, statistiques, gestion de contenu, outils métiers ou tableaux de bord.",
      items: [
        "Interfaces admin",
        "Gestion de contenu",
        "Dashboards personnalisés",
        "Outils internes sur mesure",
      ],
    },
    {
      number: "05",
      title: "Stratégie produit",
      description:
        "Avant le développement, nous vous aidons à clarifier les priorités, cadrer les fonctionnalités et construire une vision produit cohérente, réaliste et alignée avec vos objectifs.",
      items: [
        "Cadrage du besoin",
        "Priorisation des fonctionnalités",
        "Conseil technique",
        "Vision long terme",
      ],
    },
    {
      number: "06",
      title: "Suivi & évolutions",
      description:
        "Une fois le projet lancé, nous restons présents pour corriger, améliorer, optimiser et faire évoluer le produit avec méthode, cohérence et exigence.",
      items: [
        "Améliorations continues",
        "Maintenance technique",
        "Optimisations UX",
        "Ajout de nouvelles fonctionnalités",
      ],
    },
  ];

  const included = [
    "Échange de cadrage",
    "Conseil sur la solution à mettre en place",
    "Direction créative cohérente avec votre image",
    "Développement propre et structuré",
    "Accompagnement jusqu'à la mise en ligne",
    "Vision durable et évolutive du projet",
  ];

  const faq = [
    {
      question: "Travaillez-vous uniquement sur des applications mobiles ?",
      answer:
        "Non. Nous intervenons aussi sur des sites web, des interfaces d'administration, du design produit et des écosystèmes digitaux plus complets selon les besoins du projet.",
    },
    {
      question: "Pouvez-vous accompagner un projet dès l'idée initiale ?",
      answer:
        "Oui. Nous pouvons intervenir dès la phase de réflexion pour aider à cadrer le besoin, structurer les fonctionnalités et définir une direction produit claire avant le développement.",
    },
    {
      question: "Proposez-vous aussi la maintenance et les évolutions ?",
      answer:
        "Oui. Une fois le produit en ligne, nous pouvons continuer à l'améliorer, corriger certains points, optimiser l'expérience et développer les évolutions futures.",
    },
    {
      question: "Travaillez-vous avec des petites structures ?",
      answer:
        "Oui. Nous adaptons notre approche selon le niveau de maturité du projet, les enjeux et les moyens disponibles, tout en conservant un niveau d'exigence élevé sur le fond comme sur la forme.",
    },
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-black selection:bg-black selection:text-white">
      <div className="absolute inset-0 z-0 h-[100vh]">
        <img
          src={bgHero}
          alt="Background"
          className="w-full h-full object-cover pt-20"
        />
      </div>

      <NavBar />

      {/* HERO */}
      <section className="relative z-10 px-6 pt-20 pb-24 md:pt-24 md:pb-32 text-center">
        <div className="mb-6 flex items-center justify-center">
          <div className="rounded-full border border-black/10 bg-white/70 px-4 py-2 backdrop-blur-md shadow-[0_6px_20px_rgba(0,0,0,0.05)]">
            <p className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#b98c42]">
              Services NoxZi
            </p>
          </div>
        </div>

        <h1 className="text-[2.2rem] md:text-[5.6rem] leading-[0.92] tracking-[-0.08em] font-[600] font-asap text-black max-w-6xl mx-auto">
          Des services conçus
          <br className="hidden md:block" />
          pour donner de la valeur
          <br className="hidden md:block" />
          à votre projet digital
        </h1>

        <p className="mt-7 text-[17px] md:text-[21px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
          Application mobile, site web, design, interface d'administration ou
          accompagnement produit : nous construisons des solutions sur mesure,
          solides, élégantes et pensées pour durer.
        </p>

        <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
          <a
            href="https://cal.com/noxzi/30min"
            className="font-asap bg-black text-white px-6 py-3 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform inline-flex items-center gap-2"
          >
            Réserver un appel
            <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 invert" />
          </a>

          <a
            href="mailto:contact@noxzi.fr"
            className="font-asap border border-black/20 text-black px-6 py-3 rounded-full hover:bg-black hover:text-white transition-all inline-flex items-center"
          >
            Nous contacter
          </a>
        </div>

        <div className="mt-16 flex justify-center">
          <div className="relative w-full max-w-5xl overflow-hidden rounded-[36px] border border-white/40 bg-white/60 backdrop-blur-xl shadow-[0_24px_80px_rgba(0,0,0,0.08)] p-8 md:p-12">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.10),transparent_30%)]" />
            <div className="relative z-10 grid md:grid-cols-3 gap-6 text-left">
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Sur mesure
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  Chaque projet est pensé selon vos enjeux, votre image et vos objectifs réels.
                </p>
              </div>
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Exigence
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  Nous travaillons autant la cohérence produit que la qualité d'exécution.
                </p>
              </div>
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Durabilité
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  L'objectif n'est pas seulement de lancer un projet, mais de construire une base solide.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="absolute top-[70vh] left-0 w-full h-96 bg-[linear-gradient(180deg,rgba(255,255,255,0)_4.41%,#fff_76.1%)] mix-blend-lighten z-20 pointer-events-none" />

      {/* INTRO */}
      <section className="relative z-10 px-6 py-16">
        <div className="max-w-5xl mx-auto">
          <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
            Notre approche
          </p>
          <h2 className="text-[2.5rem] md:text-[5rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
            Des prestations pensées
            <br className="hidden md:block" />
            comme un ensemble cohérent
          </h2>
          <p className="text-[17px] md:text-[20px] text-black/60 font-asap leading-relaxed max-w-3xl">
            Nous ne livrons pas simplement des écrans ou du code. Nous construisons
            une solution digitale cohérente, avec une réflexion produit, une direction
            visuelle forte et une base technique pensée pour évoluer avec votre activité.
          </p>
        </div>
      </section>

      {/* SERVICES */}
      <section className="relative px-6 py-20 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-12 left-[8%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.06] blur-3xl" />
          <div className="absolute bottom-10 right-[8%] w-80 h-80 rounded-full bg-black/[0.03] blur-3xl" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid md:grid-cols-2 gap-6">
          {services.map((service) => (
            <div
              key={service.number}
              className="group relative overflow-hidden rounded-[34px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_70px_rgba(0,0,0,0.08)]"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,163,95,0.10),transparent_34%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

              <div className="relative z-10">
                <div className="flex items-start justify-between mb-10">
                  <span className="text-[64px] leading-none tracking-[-0.08em] font-[600] font-asap text-black/10">
                    {service.number}
                  </span>
                  <div className="w-12 h-12 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center">
                    <img
                      src={Logobgtransparentblack}
                      alt="NoxZi"
                      className="w-5 h-5 object-contain opacity-80"
                    />
                  </div>
                </div>

                <h3 className="text-[30px] leading-[1.02] tracking-[-0.05em] font-asap font-[500] text-black mb-4">
                  {service.title}
                </h3>

                <p className="text-black/60 font-asap leading-relaxed text-[15.5px] mb-8">
                  {service.description}
                </p>

                <div className="grid sm:grid-cols-2 gap-3">
                  {service.items.map((item) => (
                    <div
                      key={item}
                      className="rounded-[18px] border border-black/[0.06] bg-white/90 px-4 py-3 text-[14px] font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.025)]"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* INCLUDED */}
      <section className="relative px-6 py-32 bg-[linear-gradient(180deg,#fbfbfb_0%,#f3f3f3_100%)] overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-[0.95fr_1.05fr] gap-14 items-center">
          <div className="relative">
            <div className="absolute -inset-6 rounded-[46px] bg-gradient-to-b from-[#c9a35f]/10 to-transparent blur-2xl opacity-70" />
            <div className="relative overflow-hidden rounded-[40px] border border-white/10 bg-black px-8 py-10 md:px-10 md:py-12 shadow-[0_35px_110px_rgba(0,0,0,0.22)]">
              <div className="absolute inset-0 opacity-[0.08]">
                <img src={bgHero} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.22),transparent_28%)]" />

              <div className="relative z-10">
                <p className="font-asap uppercase tracking-[0.28em] text-[10px] text-[#d1a75f] mb-4">
                  Ce qui nous distingue
                </p>
                <h3 className="text-[2rem] md:text-[2.8rem] leading-[0.98] tracking-[-0.06em] font-asap font-[500] text-white mb-5">
                  Une approche produit, créative et technique à la fois
                </h3>
                <p className="text-white/70 font-asap leading-relaxed text-[16px] md:text-[18px]">
                  Nous réunissons direction visuelle, réflexion produit et exigence
                  technique pour construire des expériences digitales cohérentes et crédibles.
                </p>
              </div>
            </div>
          </div>

          <div>
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Ce qui est inclus
            </p>
            <h2 className="text-[2.8rem] md:text-[5.1rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-7">
              Un cadre de travail
              <br className="hidden md:block" />
              clair et qualitatif
            </h2>
            <div className="space-y-4">
              {included.map((item, index) => (
                <div
                  key={item}
                  className="rounded-[22px] border border-black/[0.06] bg-white/95 px-5 py-4 font-asap text-black shadow-[0_6px_18px_rgba(0,0,0,0.03)]"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-9 h-9 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center text-[12px] tracking-[0.14em] font-asap font-[600] text-[#b98c42] shrink-0">
                      0{index + 1}
                    </div>
                    <p className="text-black/80 leading-relaxed">{item}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="relative px-6 py-32 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[70%] h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          <div className="text-center mb-16">
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              FAQ
            </p>
            <h2 className="text-[2.6rem] md:text-[5rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black mb-6">
              Questions fréquentes
            </h2>
            <p className="text-[17px] md:text-[20px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
              Quelques réponses aux questions qui reviennent le plus souvent avant de démarrer un projet.
            </p>
          </div>

          <div className="space-y-5">
            {faq.map((item) => (
              <div
                key={item.question}
                className="rounded-[28px] border border-black/[0.06] bg-white p-7 shadow-[0_10px_28px_rgba(0,0,0,0.035)]"
              >
                <h3 className="text-[24px] leading-[1.05] tracking-[-0.04em] font-asap font-[500] text-black mb-3">
                  {item.question}
                </h3>
                <p className="text-black/60 font-asap leading-relaxed text-[15.5px]">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="px-6 pb-36">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-[48px] bg-black text-white px-8 py-16 md:px-14 md:py-24 shadow-[0_40px_120px_rgba(0,0,0,0.22)]">
            <div className="absolute inset-0 opacity-[0.10]">
              <img src={bgHero} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.16),transparent_26%)]" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />
            <div className="absolute -top-24 right-0 w-72 h-72 rounded-full bg-[#c9a35f]/[0.12] blur-3xl" />
            <div className="absolute -bottom-24 left-0 w-72 h-72 rounded-full bg-white/10 blur-3xl" />

            <div className="relative z-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
              <div className="max-w-3xl">
                <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#d1a75f] mb-5">
                  Prêt à avancer ?
                </p>
                <h2 className="text-[2.9rem] md:text-[5.5rem] leading-[0.94] tracking-[-0.08em] font-[600] font-asap mb-6">
                  Parlons de votre projet
                </h2>
                <p className="text-white/70 text-[17px] md:text-[20px] font-asap leading-relaxed max-w-2xl">
                  Nous pouvons vous aider à cadrer, concevoir et construire une
                  solution digitale cohérente, élégante et adaptée à vos enjeux.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://cal.com/noxzi/30min"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Réserver un appel
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </a>
                <a
                  href="mailto:contact@noxzi.fr"
                  className="inline-flex items-center justify-center rounded-full border border-white/[0.18] px-7 py-3.5 font-asap font-medium text-white transition-all duration-300 hover:bg-white hover:text-black"
                >
                  Nous contacter
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}